module.exports = __webpack_public_path__ + "static/media/customer-care.19db620d.png";